let $ = window.jQuery;
function onDocumentReady() {
    /* Circle animation */
	if ($('.circle-container').length) {
        let num = 0;
        $('.circle-animation').attr('data-percent', num);
        $('.circle-animation').attr('data-text', '0%');

        $(document).on('scroll', function() {
            checkAnimation();
        });
    }
    function isElementInViewport(elem) {
        var $elem = $(elem);
        var scrollElem = (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) ? 'body' : 'html';
        var viewportTop = $(scrollElem).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        var elemTop = Math.round( $elem.offset().top );
        var elemBottom = elemTop + $elem.height();
        return ((elemTop < viewportBottom) && (elemBottom > viewportTop));
    }
    function checkAnimation() {
        var $elem = $('.circle-container');
        if (isElementInViewport($elem)) {
            if($elem.hasClass('start')) return;
                animateCircle();
            if( $().circliful ) {
                $('.circle-animation').circliful();
                $elem.addClass('start');
            }
        }
    }
    function animateCircle() {
        $('.circle-container').find('.circle-box').each(function(){
        var value = $(this).find('.hidden-percentage').val().replace('%', '');
        if(!$.isNumeric(value)){
            value = 100;
        }

        $(this).find('.circle-animation').attr('data-percent', value);
        $(this).find('.circle-animation').attr('data-text', $(this).find('.hidden-percentage').val());
        });
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/stats-controller.js